/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlockContent } from '../../models/block-content';
import { BlockContentApiRespModel } from '../../models/block-content-api-resp-model';

export interface ApiMasterBlockContentEditPost$Params {
      body?: BlockContent
}

export function apiMasterBlockContentEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterBlockContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<BlockContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterBlockContentEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BlockContentApiRespModel>;
    })
  );
}

apiMasterBlockContentEditPost.PATH = '/api/Master/BlockContent/Edit';
